export const ActionTypes = {
    LOGGEDIN : 'LOGGEDIN',
    ADD_TOKEN: 'ADD_TOKEN',
    REMOVE_TOKEN: 'REMOVE_TOKEN'
}